/**
 * Created by mukund on 12/15/15.
 */

'use strict';

angular.module('mediacloudApp')
    .factory('batchTranscodeReport', function ($resource) {
        return $resource('api/report/transcode/batch');
    });
